// components/QuestionEditor.tsx
import React, { useState, useEffect } from 'react';
import {
    getQuestions,
    addQuestion,
    updateQuestion,
    updateQuestionSortOrder,
    uploadQuestionImage,
    deleteQuestion, deleteAnswer
} from '../services/api';
import { addAnswer, updateAnswer, uploadAnswerImage } from '../services/api';
import { Modal, Button, TextField, Box, Typography, IconButton } from '@mui/material';
import {QuestionModel} from "../services/types";
import {Add, Folder, Delete, CloudUpload, ArrowBack} from '@mui/icons-material';
import Icon from "../components/Icon";
import EditorToggle from "./EditorToggle";
const QuestionEditor: React.FC<{ quizId: string; section: number }> = ({ quizId, section }) => {
    const [questions, setQuestions] = useState<QuestionModel[]>([]);
    const [openModal, setOpenModal] = useState(false);
    const [modalType, setModalType] = useState('addQuestion');
    const [questionId, setQuestionId] = useState('');
    const [answerId, setAnswerId] = useState('');
    const [newQuestion, setNewQuestion] = useState('');
    const [newQuestionCorrect, setNewQuestionCorrect] = useState('');
    const [newQuestionNoCorrect, setNewQuestionNoCorrect] = useState<boolean>(false);
    const [newQuestionOneanswer, setNewQuestionOneanswer] = useState<boolean>(false);
    const [newQuestionIncorrect, setNewQuestionIncorrect] = useState('');
    const [newQuestionFinish, setNewQuestionFinish] = useState('');
    const [newQuestionImage, setNewQuestionImage] = useState('');
    const [newAnswerImage, setNewAnswerImage] = useState('');
    const [newAnswer, setNewAnswer] = useState('');
    const [isCorrect, setIsCorrect] = useState(false);
    const [noCorrect, setNoCorrect] = useState(false);
    const [file, setFile] = useState<File | null>(null);

    useEffect(() => {
        fetchQuestions();
    }, [quizId, section]);

    const fetchQuestions = async () => {
        try {
            const response = await getQuestions({
                page: 1,
                limit: 10,
                quiz_id: quizId,
                section,
                sort_by: 'created_at',
                sort_order: 'desc',
            });
            setQuestions(response.items);
        } catch (error) {
            console.error('Error fetching questions:', error);
        }
    };
    const handleAddQuestion = async () => {
        try {
            await addQuestion({ title: newQuestion, section, quiz_id: quizId, nocorrect: newQuestionNoCorrect, sort: 0 });
            setNewQuestion('');
            setOpenModal(false);
            fetchQuestions();
        } catch (error) {
            console.error('Error adding question:', error);
        }
    };

    const handleAddAnswer = async (questionId: string) => {
        try {
            await addAnswer({ text: newAnswer, question_id: questionId, is_correct: isCorrect, sort: 0 });
            setNewAnswer('');
            setOpenModal(false);
            fetchQuestions();
        } catch (error) {
            console.error('Error adding answer:', error);
        }
    };

    const handleEditQuestion = async () => {
        try {
            // Обновление вопроса
            const questionData = {
                title: newQuestion,
                nocorrect: newQuestionNoCorrect,
                oneanswer: newQuestionOneanswer,
                correct_answer_text: newQuestionCorrect,
                incorrect_answer_text: newQuestionIncorrect,
                finish_answer_text: newQuestionFinish,
                section: section,
                quiz_id: quizId,
                sort: 0
            }
            await updateQuestion(questionId, questionData );
            setNewQuestion('');
            setOpenModal(false);
            fetchQuestions();
        } catch (error) {
            console.error('Error editing question:', error);
        }
    };

    const handleEditAnswer = async () => {
        try {
            // Обновление ответа
            const answerData = {
                text: newAnswer,
                question_id: questionId,
                is_correct: isCorrect,
                sort: 0
            }
            await updateAnswer(answerId, answerData);
            setNewAnswer('');
            setOpenModal(false);
            fetchQuestions();
        } catch (error) {
            console.error('Error editing answer:', error);
        }
    };

    const handleDeleteQuestion = async (questionId: string) => {
        try {
            // Удаление вопроса
            await deleteQuestion(questionId);
            fetchQuestions();
        } catch (error) {
            console.error('Error deleting question:', error);
        }
    };

    const handleDeleteAnswer = async (answerId: string) => {
        try {
            // Удаление ответа
            await deleteAnswer(answerId);
            fetchQuestions();
        } catch (error) {
            console.error('Error deleting answer:', error);
        }
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files![0];
        setFile(file);
    };


    const handleUploadQuestionImage = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if (!files) return; // Проверка на null

        const file = files[0];

        uploadQuestionImage(questionId, file)
            .then((response) => {
                setNewQuestionImage( response.image );
            })
            .catch((error) => console.error('Error uploading quiz image:', error));
    };

    const handleRemoveAnswerImage = async () => {
        setNewAnswerImage('')
        try {
            // Обновление ответа
            const answerData = {
                text: newAnswer,
                question_id: questionId,
                is_correct: isCorrect,
                sort: 0,
                image: ''
            }
            await updateAnswer(answerId, answerData);
        } catch (error) {
            console.error('Error editing answer:', error);
        }
    };
    const handleRemoveQuestionImage = async () => {
        setNewQuestionImage('')
        try {
            const questionData = {
                title: newQuestion,
                nocorrect: newQuestionNoCorrect,
                oneanswer: newQuestionOneanswer,
                correct_answer_text: newQuestionCorrect,
                incorrect_answer_text: newQuestionIncorrect,
                finish_answer_text: newQuestionFinish,
                section: section,
                quiz_id: quizId,
                sort: 0,
                image: ''
            }
            await updateQuestion(questionId, questionData );
        } catch (error) {
            console.error('Error editing answer:', error);
        }


    };

    const handleUploadAnswerImage = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if (!files) return; // Проверка на null

        const file = files[0];

        uploadAnswerImage(answerId, file)
            .then((response) => {
                setNewAnswerImage( response.image );
            })
            .catch((error) => console.error('Error uploading quiz image:', error));
    };

    return (
        <Box sx={{mt: 2, p:2, background:'#0000000a'}}>
            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>

                <Typography variant="h6">Вопросы</Typography>
                <Button onClick={() => {
                    setModalType('addQuestion');
                    setOpenModal(true);
                }}><Add/> добавить вопрос</Button>
            </Box>
            {questions.map((question) => (
                <Box>
                    <Box className='scenarioItem' key={question.id} sx={{display: 'flex', alignItems: 'center', mt: 2, backgroundColor: '#fff'}}>
                        <Box sx={{flexGrow: 1}} className='scenarioItemTitle'>{question.title}</Box>
                        <Box>
                            <Button onClick={() => {
                                setModalType('addAnswer');
                                setQuestionId(question.id);
                                setOpenModal(true);
                            }}>Добавить ответ</Button>
                            <IconButton onClick={() => {
                                setModalType('editQuestion');
                                setQuestionId(question.id);
                                setNewQuestion(question.title);
                                setNewQuestionNoCorrect(question.nocorrect);
                                setNewQuestionOneanswer(question.oneanswer);
                                setNewQuestionCorrect(question.correct_answer_text);
                                setNewQuestionIncorrect(question.incorrect_answer_text);
                                setNewQuestionFinish(question.finish_answer_text);
                                setNewQuestionImage(question.image);
                                setOpenModal(true);
                            }}><Icon name="edit" /></IconButton>
                            <IconButton onClick={() => handleDeleteQuestion(question.id)}><Icon name="remove" /></IconButton>
                        </Box>
                    </Box>
                    {question.answers.map((answer) => (
                        <Box className={answer.is_correct ? 'scenarioItem correctItem': 'scenarioItem'} key={answer.id} sx={{display: 'flex', alignItems: 'center', mt: 1, ml: 4, backgroundColor: '#00000011'}}>
                            <Box sx={{flexGrow: 1}} className='scenarioItemTitle'>{answer.text}</Box>
                            <Box>
                                <IconButton onClick={() => {
                                    setModalType('editAnswer');
                                    setNewAnswer(answer.text);
                                    setQuestionId(answer.question_id);
                                    setNewAnswerImage(answer.image);
                                    setAnswerId(answer.id);
                                    setIsCorrect(answer.is_correct);
                                    setOpenModal(true);
                                }}><Icon name="edit" /></IconButton>
                                <IconButton onClick={() => handleDeleteAnswer(answer.id)}><Icon name="remove" /></IconButton>
                            </Box>
                        </Box>
                    ))}
                </Box>
            ))}

            {/* Модальное окно */}
            <Modal open={openModal} onClose={() => setOpenModal(false)}>
                <Box sx={{minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center', overflowY: 'scroll', height: '100vh'}}>
                    <Box sx={{ p: 4, bgcolor: 'white', margin: 'auto', width: 900,borderRadius: 2 }}>
                        <Typography id="modal-modal-title" variant="h6" sx={{ mb: 2 }}>
                            {modalType === 'addQuestion' ? 'Добавить вопрос' : modalType === 'addAnswer' ? 'Добавить ответ' : 'Редактировать'}
                        </Typography>
                        <TextField
                            fullWidth
                            label={modalType === 'addQuestion' ? 'Вопрос' : 'Ответ'}
                            value={modalType === 'addQuestion' || modalType === 'editQuestion' ? newQuestion : newAnswer}
                            type="text"
                            onChange={(e) => {
                                if (modalType === 'addQuestion' || modalType === 'editQuestion') {
                                    setNewQuestion(e.target.value);
                                } else {
                                    setNewAnswer(e.target.value);
                                }
                            }}
                            sx={{mb: 2}}
                        />



                        {modalType === 'addAnswer' || modalType === 'editAnswer' && (
                            <Box sx={{mb: 2}}>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={isCorrect}
                                        onChange={(e) => setIsCorrect(e.target.checked)}
                                    />
                                    Верный
                                </label>
                            </Box>
                        )}

                        {(modalType === 'editQuestion')  && (
                            <>

                                <EditorToggle
                                    width="100%"
                                    label="При верном ответе"
                                    initialValue={newQuestionCorrect}
                                    onChange={setNewQuestionCorrect}
                                />
                                <EditorToggle
                                    width="100%"
                                    label="При не верном ответе"
                                    initialValue={newQuestionIncorrect}
                                    onChange={setNewQuestionIncorrect}
                                />
                                <EditorToggle
                                    width="100%"
                                    label="Текст после ответа"
                                    initialValue={newQuestionFinish}
                                    onChange={setNewQuestionFinish}
                                />

                                <Box sx={{mb: 2}}>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={newQuestionNoCorrect}
                                            onChange={(e) => setNewQuestionNoCorrect(e.target.checked)}
                                        />
                                        Не имеет верного ответа
                                    </label>
                                </Box>
                                <Box sx={{mb: 2}}>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={newQuestionOneanswer}
                                            onChange={(e) => setNewQuestionOneanswer(e.target.checked)}
                                        />
                                        Имеет только один ответ
                                    </label>
                                </Box>
                            </>
                        )}


                        <Box sx={{display: 'flex', gap: '10px', mt: 2}}>
                            {(modalType === 'editQuestion')  && (
                                <>
                                    <img src={newQuestionImage} alt="" width='300'
                                         style={{aspectRatio: "1", objectFit: 'cover'}}/>
                                    <input
                                        accept="image/*"
                                        type="file"
                                        onChange={handleUploadQuestionImage}
                                        style={{display: 'none'}}
                                        id="question-upload"
                                    />
                                    <label htmlFor="question-upload">
                                        <Button variant="contained" className='profileBtn' component="span"
                                                sx={{mb: 2, background: '#3a485b'}}>
                                            Загрузить фото
                                        </Button>
                                    </label>
                                    <Button variant="contained" className='profileBtn' component="span" onClick={handleRemoveQuestionImage}
                                            sx={{mb: 2, background: 'rgba(237,28,36,0.87)', verticalAlign: 'top', height: '37px'}}>
                                        Удалить фото
                                    </Button>
                                </>

                            )}
                            {(modalType === 'editAnswer') && (
                                <>
                                    <img src={newAnswerImage} alt=""  width='300'
                                         style={{aspectRatio: "1", objectFit: 'cover'}}/>
                                    <input
                                        accept="image/*"
                                        type="file"
                                        onChange={handleUploadAnswerImage}
                                        style={{display: 'none'}}
                                        id="answer-upload"
                                    />
                                    <label htmlFor="answer-upload">
                                        <Button variant="contained" className='profileBtn' component="span"
                                                sx={{mb: 2, background: '#3a485b'}}>
                                            Загрузить фото
                                        </Button>
                                    </label>
                                    <Button variant="contained" className='profileBtn' component="span" onClick={handleRemoveAnswerImage}
                                            sx={{mb: 2, background: 'rgba(237,28,36,0.87)', verticalAlign: 'top', height: '37px'}}>
                                        Удалить фото
                                    </Button>
                                </>
                        )}

                    </Box>

                    <Box sx={{display: 'flex', justifyContent: 'space-between', mt: 3}}>
                        {modalType === 'addQuestion' && (
                            <Button onClick={handleAddQuestion}>Добавить вопрос</Button>
                            )}
                            {modalType === 'addAnswer' && (
                                <Button onClick={() => handleAddAnswer(questionId)}>Добавить ответ</Button>
                            )}
                            {modalType === 'editQuestion' && (
                                <Button onClick={handleEditQuestion}>Сохранить изменения</Button>
                            )}
                            {modalType === 'editAnswer' && (
                                <Button onClick={() => handleEditAnswer()}>Сохранить изменения</Button>
                            )}
                            <Button onClick={() => setOpenModal(false)} sx={{ ml: 2 }}>
                                Отмена
                            </Button>
                        </Box>

                    </Box>
                </Box>
            </Modal>

        </Box>
    );
};

export default QuestionEditor;
